import { HttpContextToken } from '@angular/common/http';

/**
 * Marks requests that should surface 401 errors to the feature instead of triggering
 * the global session-expiration flow.
 */
export const HANDLE_401_LOCALLY = new HttpContextToken<boolean>(() => false);
